module.exports = __webpack_public_path__ + "img/Carrosserielackiererin_AB_019.55b6d3d4.jpg";